import mixpanel from 'mixpanel-browser';

const initMixpanel = () => {
    if (process.env.NODE_ENV === 'production') {
        mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);
    } else {
        mixpanel.init('fake_token', { debug: true });
    }
};

initMixpanel();

export const useMixpanel = () => {
    const trackEvent = (eventName, trackingData, shouldEnrichData = true) => {
        try {
            const payload = shouldEnrichData ? { ...trackingData, ...addMetadataEnrichment() } : trackingData;
            mixpanel.track(eventName, payload);
        } catch (err) {}
    };
    return { trackEvent };
};

const addMetadataEnrichment = () => {
    return {
        'App Name': 'BeeheroAccounts',
        'Is Production': process.env.NODE_ENV === 'production'
    };
};
